export default __webpack_public_path__ + "static/media/activeHeaderHome.5c2ffe6c.svg";